import {
  UPDATED_ADVANCED_APPOINTMENT_STEP_DATA,
  UPDATED_END_DATE_DATE_PICKER_VISIBILITY,
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
  GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION,
  GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION,
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION
} from "../actions/appointmentAdvancedStep";
import {
  SAVED_BOOKING_FORM,
  GOT_EXISTING_BOOKING,
  GOT_SIBBLING_BOOKING,
  GOT_PURCHASED_OFFER,
  REMOVE_OFFER_FROM_FORM
} from "../actions/booking";
import {
  GOT_STAFF_SERVICES_AND_MORE,
  UPDATED_APPOINTMENT_STEP_START_DATE_TIME
} from "../actions/appointmentStep";
import { ERROR_SAVING_BOOKING_FORM } from "../actions/booking";
import {
  apiLocalTimeToMoment,
  isInRange,
  convertDateTimeFromApi,
  convertTimeFromApi,
  convertApiUtcToLocalMoment
} from "../utils/helpers";
import {
  advancedAppointmentStepInitialState,
  offersStatusEnum,
  dayValues
} from "../state/initialState";
import objectAssign from "object-assign";
import { clone } from "./helper";
import moment from "moment";

export default (state = advancedAppointmentStepInitialState, action) => {
  let newStatus = {};
  switch (action.type) {
    case UPDATED_APPOINTMENT_STEP_START_DATE_TIME:
      newStatus = clone(state.advancedAppointmentStepData);
      window.moment = moment;
      let selectedRepeatOnOptionsSelected = [];
      let listOfNonEditableRepeatOnOptionsSelected = [];
      let clonedDays = clone(dayValues);
      if (moment(action.data.date).day() == 0) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Sun);
        selectedRepeatOnOptionsSelected.push(clonedDays.Sun);
      } else if (moment(action.data.date).day() == 1) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Mon);
        selectedRepeatOnOptionsSelected.push(dayValues.Mon);
      } else if (moment(action.data.date).day() == 2) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Tue);
        selectedRepeatOnOptionsSelected.push(dayValues.Tue);
      } else if (moment(action.data.date).day() == 3) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Wed);
        selectedRepeatOnOptionsSelected.push(dayValues.Wed);
      } else if (moment(action.data.date).day() == 4) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Thu);
        selectedRepeatOnOptionsSelected.push(dayValues.Thu);
      } else if (moment(action.data.date).day() == 5) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Fri);
        selectedRepeatOnOptionsSelected.push(dayValues.Fri);
      } else if (moment(action.data.date).day() == 6) {
        listOfNonEditableRepeatOnOptionsSelected.push(clonedDays.Sat);
        selectedRepeatOnOptionsSelected.push(dayValues.Sat);
      }

      newStatus.selectedLocationId = action.data.selectedLocationId;
      newStatus.selectedRecurringOnDate = action.data.date;
      newStatus.selectedEndDate = action.data.date;
      newStatus.listOfNonEditableRepeatOnOptionsSelected = listOfNonEditableRepeatOnOptionsSelected;
      newStatus.selectedRepeatOnOptionsSelected = selectedRepeatOnOptionsSelected;
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });
    case REMOVE_OFFER_FROM_FORM:
      newStatus = clone(state.advancedAppointmentStepData);
      newStatus.validOfferPurchasedId = "";
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });
    case GOT_PURCHASED_OFFER:
      if (action.data.found) {
        newStatus = clone(state.advancedAppointmentStepData);
        newStatus.validOfferPurchasedId = (action.data.purchase || {}).id || "";
      } else {
        newStatus = state.advancedAppointmentStepData;
      }
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });
    case UPDATED_ADVANCED_APPOINTMENT_STEP_DATA:
      return objectAssign({}, state, {
        advancedAppointmentStepData: action.data
      });
    case GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION:
      return objectAssign({}, state, {
        loadingAvailabilityDatesForSpecificRecurringSection: true
      });
    case GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_SPECIFIC_RECURRING_SECTION:
      newStatus = clone(state.advancedAppointmentStepData);
      let clonedBookingResultsForRecurring = clone(action.data);
      let bookingsTimeLineForRecurring =
        clonedBookingResultsForRecurring.bookingstimeline;
      const doubleBookingsTimelineRecurring =
        clonedBookingResultsForRecurring.doublebookingstimeline;
      // checking if double bookings enabled
      const bookingsForRecurring = bookingsTimeLineForRecurring.concat(
        doubleBookingsTimelineRecurring
      ); //newStatus.doubleBookingEnabled === true ? doubleBookingsTimeline : bookingsTimeLine.concat(doubleBookingsTimeline);
      let selectedDateRecurring = action.data.newlySelectedDate;
      selectedDateRecurring =
        selectedDateRecurring.replace(":", "").replace(/-/g, "") + "L";

      newStatus.timeListForOnTimeRecurring.forEach(item => {
        item.disabled = false;
      }); // start with a clean list

      // Reset unavailable times
      newStatus.unavailableSpecificRecurringTimeList = [];

      bookingsForRecurring.forEach(booking => {
        // looping over existing bookings for resource for selected day
        // convert api times to moment times
        const localstarttime = apiLocalTimeToMoment(booking.localstarttime);
        const localendtime = apiLocalTimeToMoment(booking.localendtime);

        newStatus.unavailableSpecificRecurringTimeList.push({
          from: convertTimeFromApi(localstarttime),
          to: convertTimeFromApi(localendtime)
        });

        // looping over time options in dropdown
        newStatus.timeListForOnTimeRecurring.forEach((item, i) => {
          let compareDate = `${selectedDateRecurring.split("T")[0]}T${
            item.stringValue
          }00L`;
          let _compareDate = apiLocalTimeToMoment(compareDate);
          // checking if current time option is in booked out array
          if (isInRange(_compareDate, localstarttime, localendtime)) {
            // setting time option as not available (disabled)
            item.disabled = true;
          }
        });
      });

      if (bookingsForRecurring.length == 0) {
        newStatus.timeListForOnTimeRecurring.forEach(x => {
          x.disabled = false;
        });
      }
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus,
        loadingAvailabilityDatesForSpecificRecurringSection: false,
        loadedAvailabilitiesForSpecificRecurringAtLeastOnce: true
      });
    case UPDATED_END_DATE_DATE_PICKER_VISIBILITY:
      return objectAssign({}, state, {
        openEndDatePickerAppointment: action.data
      });
    case GOT_EXISTING_BOOKING:
      newStatus = clone(state.advancedAppointmentStepData);
      let mergedData = objectAssign(
        {},
        newStatus,
        action.data.advancedAppointmentStepData
      );
      let modifiedState = objectAssign({}, state, {
        advancedAppointmentStepData: mergedData,
        advancedAppointmentStepDataFromLastSave: clone(mergedData),
        advancedAppointmentStepDataBeforeUserHasMadeAnyChanges: clone(
          mergedData
        )
      });
      return modifiedState;
    case ERROR_SAVING_BOOKING_FORM:
      newStatus = clone(state.advancedAppointmentStepData);
      if (action.data && action.data.clashes) {
        let clashDates = action.data.clashes;
        let translatedClashes = action.data.clashes.map((o, i) => {
          let convertedTime = convertApiUtcToLocalMoment(
            o.start,
            window.userTimezone
          );
          return {
            startDateAndTime: convertDateTimeFromApi(convertedTime),
            startTime: convertTimeFromApi(convertedTime),
            temporarilySelectedTimeForClash: ""
          };
        });
        newStatus.futureAppointmentClashes = translatedClashes;

        newStatus.futureAppointmentClashesResolved = []; //override any selection previously made
      }

      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });
    case GOT_SIBBLING_BOOKING:
      newStatus = clone(state.advancedAppointmentStepData);
      newStatus.multiServiceAdvancedList = newStatus.multiServiceAdvancedList.concat(
        action.data.advancedAppointmentStepData.multiServiceAdvancedList
      );
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });

    case GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION:
      newStatus = clone(state.advancedAppointmentStepData);
      let clonedBookingResults = clone(action.data);
      let bookingsTimeLine = clonedBookingResults.bookingstimeline;
      const doubleBookingsTimeline =
        clonedBookingResults.doublebookingstimeline;

      // checking if double bookings enabled
      const bookings = bookingsTimeLine.concat(doubleBookingsTimeline); //newStatus.doubleBookingEnabled === true ? doubleBookingsTimeline : bookingsTimeLine.concat(doubleBookingsTimeline);

      let selectedDate = action.data.newlySelectedDate;
      selectedDate = selectedDate.replace(":", "").replace(/-/g, "") + "L";

      newStatus.timeListForClashes.forEach(item => {
        item.disabled = false;
      }); // start with a clean list

      bookings.forEach(booking => {
        // looping over existing bookings for resource for selected day
        // convert api times to moment times
        const localstarttime = apiLocalTimeToMoment(booking.localstarttime);
        const localendtime = apiLocalTimeToMoment(booking.localendtime);

        // looping over time options in dropdown
        // newStatus.timeListForClashes.forEach((item,i) => {
        //     let compareDate = `${selectedDate.split("T")[0]}T${item.stringValue}00L`;
        //     let _compareDate = apiLocalTimeToMoment(compareDate);
        //     // checking if current time option is in booked out array
        //     if(isInRange(_compareDate, localstarttime, localendtime)) {
        //         // setting time option as not available (disabled)
        //         item.disabled = true;
        //     }
        // }); // DES- 774 clashes comes only for doublebooking recurrences
      });

      if (bookings.length == 0) {
        newStatus.timeListForClashes.forEach(x => {
          x.disabled = false;
        });
      }
      (
        newStatus.futureAppointmentClashesResolved[action.data.indexOfClash] ||
        newStatus.futureAppointmentClashes[action.data.indexOfClash]
      ).loadingClash = false;
      let bookingWeUpdated = newStatus.multiServiceAdvancedList.find(
        x => x.bookingId == action.data.bookingId
      );
      if (bookingWeUpdated) {
        bookingWeUpdated.loadingTimesForCurrentResourceForClashSection = false;
        bookingWeUpdated.loadedBookingForResourceWithinDatesForClashSection = true;
      } else {
        newStatus.multiServiceAdvancedList[0].loadingTimesForCurrentResourceForClashSection = false;
        newStatus.multiServiceAdvancedList[0].loadedBookingForResourceWithinDatesForClashSection = true;
      }
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });
    case GET_BOOKINGS_FOR_RESOURCE_WITHIN_DATES_FOR_CLASH_SECTION:
      newStatus = clone(state.advancedAppointmentStepData);
      (
        newStatus.futureAppointmentClashesResolved[action.data.indexOfClash] ||
        newStatus.futureAppointmentClashes[action.data.indexOfClash]
      ).loadingClash = true;
      newStatus.multiServiceAdvancedList.find(
        x => x.bookingId == action.data.bookingId
      ).loadingTimesForCurrentResourceForClashSection = true;
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus
      });
    case GOT_STAFF_SERVICES_AND_MORE:
      newStatus = clone(state.advancedAppointmentStepData);
      if (action.data.recurrence && action.data.recurrence.frequency != "N")
        newStatus.recurringToggleOn = true;

      newStatus.doubleBookingEnabled = action.data.doublebookingenabled;
      return objectAssign({}, state, {
        advancedAppointmentStepData: newStatus,
        advancedAppointmentStepDataFromLastSave: clone(newStatus)
      });
    case SAVED_BOOKING_FORM:
      let clonedStepData = clone(state.advancedAppointmentStepData);
      clonedStepData = objectAssign(
        {},
        clonedStepData,
        action.data.advancedAppointmentStepData
      );

      clonedStepData.futureAppointmentClashes = []; // clear clashes since we saved successfully
      clonedStepData.futureAppointmentClashesResolved = []; //override any selection previously made
      clonedStepData.currentClashBeingResolved = 1;
      return objectAssign({}, state, {
        advancedAppointmentStepData: clonedStepData,
        advancedAppointmentStepDataFromLastSave: clone(
          action.data.advancedAppointmentStepData
        )
      });
    default:
      return state;
  }
  return state;
};
